import { configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import commonSlice from "./commonSlice";
import authReducer from "./authSlice";
import fieldReducer from "./fieldSlice";
import filterReducer from "./filterSlice";
import moduleDataReducer from "./moduleDataSlice";

// Separate persist configs for different reducers
const commonPersistConfig = {
  key: "common",
  storage,
};

const filterPersistConfig = {
  key: "filter",
  storage,
};

const persistedCrmsReducer = persistReducer(commonPersistConfig, commonSlice);
const persistedFilterReducer = persistReducer(
  filterPersistConfig,
  filterReducer
);

export const store = configureStore({
  reducer: {
    crms: persistedCrmsReducer,
    auth: authReducer, // No persist needed for authentication in most cases
    field: fieldReducer, // No persist added, unless required
    moduleData: moduleDataReducer, // No persist added, unless required
    filter: persistedFilterReducer, // Persist filters (optional)
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true, serializableCheck: false }),
});

// Define RootState and AppDispatch types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);
